export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7845.a07ab67a.jpg";